"use strict";
/**
 * Created by rouven on 22.04.17.
 */
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.configure = exports.Conditional = void 0;
var react_1 = __importDefault(require("react"));
var react_redux_1 = require("react-redux");
var DEFAULTS = {
    passProps: false,
    wrapperTag: 'span'
};
var configure = function (_a) {
    var _b = _a.passProps, passProps = _b === void 0 ? DEFAULTS.passProps : _b, _c = _a.wrapperTag, wrapperTag = _c === void 0 ? DEFAULTS.wrapperTag : _c;
    DEFAULTS.passProps = passProps;
    DEFAULTS.wrapperTag = wrapperTag;
};
exports.configure = configure;
/**
    * Renders (each) child if condition is true
    *
    * @param child - child to be rendered
    * @param props - passed props of child
    * @param passProps - options for rendering child
    * @param wrapperTag - options for rendering child
    *
 */
var renderChild = function (child, props, _a) {
    var passProps = _a.passProps, wrapperTag = _a.wrapperTag;
    if (typeof child === 'string')
        return react_1["default"].createElement(wrapperTag, null, child);
    if (react_1["default"].isValidElement(child) === false)
        return null;
    if (passProps === true)
        return react_1["default"].cloneElement(child, props);
    return child;
};
var mapStateToProps = function (state) { return ({
    state: state
}); };
var connector = (0, react_redux_1.connect)(mapStateToProps);
/**
    * Tests against condition with values from redux store
    *
    * @param condition - which conditional is testing against
    * @param children - allowing multible children
    * @param passProps - options for rendering child
    * @param wrapperTag - options for rendering child
    * @param state - parameters that conditional is testing
    * @param dispatch - parameters that conditional is testing
    *
 */
var ConditionalComponent = function (_a) {
    var condition = _a.condition, children = _a.children, _b = _a.passProps, passProps = _b === void 0 ? DEFAULTS.passProps : _b, _c = _a.wrapperTag, wrapperTag = _c === void 0 ? DEFAULTS.wrapperTag : _c, state = _a.state, dispatch = _a.dispatch, props = __rest(_a, ["condition", "children", "passProps", "wrapperTag", "state", "dispatch"]);
    if (condition(props, state) !== true)
        return null;
    if (children instanceof Array)
        return react_1["default"].createElement(wrapperTag, null, react_1["default"].Children.map(children, function (child) { return renderChild(child, props, { passProps: passProps, wrapperTag: wrapperTag }); }));
    return renderChild(children, props, { passProps: passProps, wrapperTag: wrapperTag });
};
var Conditional = connector(ConditionalComponent);
exports.Conditional = Conditional;
exports["default"] = Conditional;
